import { Box } from "@mui/material";
import { format, parseISO, isValid } from "date-fns";
import { getReportStatusMeta, formatOptionLabel } from "../../data";
import { ReportActionsPopover } from "./report-actions-popover";

const FormatChip = ({ label }) => (
  <Box
    sx={{
      display: "inline-flex",
      alignItems: "center",
      px: 1.5,
      py: 0.3,
      borderRadius: "999px",
      backgroundColor: "rgba(0,0,0,0.06)",
      fontSize: "0.78rem",
      fontWeight: 500,
      whiteSpace: "nowrap",
    }}
  >
    {label}
  </Box>
);

const StatusChip = ({ status }) => {
  const meta = getReportStatusMeta(status);

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        px: 1.5,
        py: 0.3,
        borderRadius: "999px",
        fontSize: "0.8rem",
        fontWeight: 500,
        whiteSpace: "nowrap",
        backgroundColor: meta.bg,
        color: meta.color,
      }}
    >
      {meta.label}
    </Box>
  );
};

const formatDate = (date, pattern = "MMM d, yyyy") => {
  if (!date) return "N/A";
  const parsed = parseISO(date);
  return isValid(parsed) ? format(parsed, pattern) : "N/A";
};

export const ReportColumns = [
  {
    accessorKey: "name",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Report Name</div>,
    cell: ({ row }) => (
      <div>
        <div
          style={{
            fontSize: "0.875rem",
            fontWeight: 600,
            whiteSpace: "nowrap",
          }}
        >
          {row.original.name ?? "N/A"}
        </div>
        {row.original.description && (
          <div
            style={{
              fontSize: "0.75rem",
              color: "rgba(0,0,0,0.5)",
              whiteSpace: "nowrap",
            }}
          >
            {row.original.description}
          </div>
        )}
      </div>
    ),
  },
  {
    accessorKey: "type",
    header: () => <div>Type</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {formatOptionLabel(row.original.type) ?? "N/A"}
      </div>
    ),
  },
  {
    id: "dateRange",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Date Range</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {formatDate(row.original.dateRangeStart, "MMM d")} -{" "}
        {formatDate(row.original.dateRangeEnd, "MMM d, yyyy")}
      </div>
    ),
  },
  {
    accessorKey: "format",
    header: () => <div>Format</div>,
    cell: ({ row }) =>
      row.original.format ? (
        <FormatChip label={row.original.format} />
      ) : (
        "N/A"
      ),
  },
  {
    accessorKey: "generatedOn",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Generated On</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {formatDate(row.original.generatedOn)}
      </div>
    ),
  },
  {
    accessorKey: "createdByName",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Created By</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {row.original.createdByName ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "status",
    header: () => <div>Status</div>,
    cell: ({ row }) => <StatusChip status={row.original.status} />,
  },
  {
    id: "actions",
    header: () => <div>Action</div>,
    cell: ({ row }) => <ReportActionsPopover report={row.original} />,
  },
];
